const authentication = require('../../../react-azure-adb2c2').default;











export const update = (values: any) => {
  // const url = process.env.REACT_APP_API_BASE_URL + `/api/v1/kyousais/update`;
  // let url = `http://localhost:5000/api/v1/kyousais/update`;
  // alert(url)
 const token = authentication.getAccessToken();
let url = 'https://go.homestation.jp/bulkreact';
  // let url =  `https://hskaku.homestation.jp/manage/contraction/rest/list/bulkreact.json`
  // const token = authentication.getAccessToken();
  // alert(url)
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));



  //  return  fetch(url, {
  //             method: 'get',
  //             // body: JSON.stringify(search),

  //             headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //         }).then(res => res.json())
  //         .then(payload => ({ payload }))
  //             .catch(error => ({ error }));
  //       return  fetch(url, {
  //       method: 'get',
  //       // body: JSON.stringify(accountinglistset),

  //       headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  //   })
  //   .then(res => res.json())
  //   .then(payload => ({ payload }))
  //       .catch(error => ({ error }));






};


